import { useRef, useState } from "react";

export function useReasoningManager() {
  const [text, setText] = useState<string>("");
  const ongoingRef = useRef(false);

  function handleStream(value: string) {
    if (value.includes("</REASONING-CBB>")) {
      ongoingRef.current = false;
      const beforeTag = value.split("</REASONING-CBB>")[0];
      setText((prev) => prev + beforeTag);
      return { ongoing: ongoingRef.current };
    }

    if (value.includes("<REASONING-CBB>")) {
      ongoingRef.current = true;
      const afterTag = value.split("<REASONING-CBB>")[1];
      setText(afterTag || "");
    } else if (ongoingRef.current) {
      setText((prev) => prev + value);
    }

    return { ongoing: ongoingRef.current };
  }

  function stop(deleteText: boolean = false) {
    if (deleteText) setText("");
    ongoingRef.current = false;
  }

  function sanitizeTags(value) {
    return value
      .replace(/^[\s\S]*?<\/REASONING-CBB>/g, "")
      .replace(/<\/?REASONING-CBB>/g, "");
  }

  return {
    text: text || "",
    ongoing: ongoingRef.current,
    handleStream,
    sanitizeTags,
    stop,
    getReasoning: () => text,
  };
}
